(function () {
  if (window.__mwMatrixRain) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  function ready(fn) {
    if (document.querySelector(".mw-matrix-line")) {
      fn();
      return;
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        if (document.querySelector(".mw-matrix-line")) fn();
      });
      return;
    }
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (document.querySelector(".mw-matrix-line")) {
        clearInterval(t);
        fn();
      } else if (n > 20) {
        clearInterval(t);
      }
    }, 50);
  }

  ready(function () {
    if (window.__mwMatrixRain) return;
    window.__mwMatrixRain = true;
    if (document.querySelector(".mw-matrix-rain")) return;

    var style = document.createElement("style");
    style.textContent = ".mw-matrix-rain{position:fixed;inset:0;width:100%;height:100%;z-index:400;pointer-events:none;opacity:0;transition:opacity .9s ease}.mw-matrix-rain.is-on{opacity:1}";
    document.head.appendChild(style);

    var canvas = document.createElement("canvas");
    canvas.className = "mw-matrix-rain";
    canvas.setAttribute("aria-hidden", "true");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext("2d");
    if (!ctx) return;

    var glyphs = "01アイウエオカキクケコサシスセソタチツテト0123456789";
    var font = 15;
    var gap = 22;
    var cols = [];
    var waves = 0;

    function size() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    function holes() {
      return Array.prototype.slice.call(document.querySelectorAll(".mw-clip--hero, .mw-clip__frame, .article-template__content iframe")).map(function (el) {
        return el.getBoundingClientRect();
      });
    }

    function wave() {
      var n = Math.max(10, Math.floor(canvas.width / gap));
      cols = [];
      for (var i = 0; i < n; i++) {
        if (Math.random() > 0.28) continue;
        cols.push({
          x: i * gap + 3,
          y: -Math.random() * 160,
          v: 0.7 + Math.random() * 0.9,
          trail: 7 + ((Math.random() * 5) | 0)
        });
      }
    }

    function finished() {
      return cols.every(function (c) {
        return c.y - c.trail * font > canvas.height + 20;
      });
    }

    var stopped = false;
    function frame() {
      if (stopped) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      var cuts = holes();
      if (cuts.length) {
        ctx.beginPath();
        ctx.rect(0, 0, canvas.width, canvas.height);
        cuts.forEach(function (r) {
          if (r.width > 20 && r.height > 20) ctx.rect(r.left, r.top, r.width, r.height);
        });
        ctx.clip("evenodd");
      }
      ctx.font = font + 'px "Share Tech Mono","Courier New",monospace';
      cols.forEach(function (c) {
        for (var t = 0; t < c.trail; t++) {
          var yy = c.y - t * font;
          if (yy < -font || yy > canvas.height + font) continue;
          ctx.fillStyle = t === 0
            ? "rgba(190,255,200,0.55)"
            : "rgba(0,255,65," + Math.max(0.08, 0.32 - t * 0.035).toFixed(3) + ")";
          ctx.fillText(glyphs.charAt((Math.random() * glyphs.length) | 0), c.x, yy);
        }
        c.y += c.v * font * 0.28;
      });
      ctx.restore();
      if (finished()) {
        waves += 1;
        if (waves >= 2) {
          canvas.classList.remove("is-on");
          stopped = true;
          setTimeout(function () {
            if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
          }, 1000);
          return;
        }
        wave();
      }
      requestAnimationFrame(frame);
    }

    size();
    wave();
    canvas.classList.add("is-on");
    requestAnimationFrame(frame);
  });
})();
